import type { Playback } from "../api/types";

export type MixPlayback = NonNullable<Playback["mix"]>;

export function isDedicatedMix(playback: Playback | null | undefined): boolean {
  return playback?.mix?.phase === "active" || playback?.mix?.phase === "draining";
}

/** Draining keeps the current audio, but the next Mix is only a reservation. */
export function mixEnabled(playback: Playback | null | undefined): boolean {
  const mix = playback?.mix;
  return mix ? mix.phase !== "draining" || !!mix.pending_mix_id : playback?.dj_mix_enabled ?? false;
}

export function mixLabel(mix: MixPlayback): string {
  if (mix.phase === "waiting") return "開始待ち";
  if (mix.phase === "preparing") return "準備中";
  if (mix.phase === "draining") return "再生終了待ち";
  return mix.pause_reasons.length ? "一時停止中" : "ミックス中";
}

export function mixDescription(mix: MixPlayback): string {
  if (mix.phase === "waiting") return "現在の曲と手動キューを流し終えてから始めます。追加した曲も先に流れます。";
  if (mix.phase === "preparing") return "Mixの音源を準備しています。手動曲を追加した場合は、その再生を優先します。";
  if (mix.phase === "draining") return "今流れている音源を最後まで流してから通常再生へ戻ります。手動曲は今から追加できます。"
    + (mix.pending_mix_id ? " 次のMixは手動曲の後に開始します。" : "");
  return "次の曲を自動で選んでいます。手動で曲を追加するには、Mixを解除してください。";
}

export function mixPauseDescription(mix: MixPlayback): string {
  const reasons: Record<MixPlayback["pause_reasons"][number], string> = {
    manual: "オーナーが一時停止しています。",
    empty: "VCに人が戻るのを待っています。",
    deafened: "全員がスピーカーミュート中です。誰かが聴ける状態に戻ると再開できます。",
    recovery: "接続の復旧を確認しています。",
  };
  return mix.pause_reasons.map((reason) => reasons[reason]).join(" ");
}

export function mixTransportButton(mix: MixPlayback): { kind: "pause" | "resume"; label: string } {
  if (mix.pause_reasons.includes("manual")) return { kind: "resume",
    label: mix.pause_reasons.length > 1 ? "手動の一時停止を解除" : "再開" };
  return { kind: "pause", label: mix.pause_reasons.length ? "自動再開を止める" : "一時停止" };
}

export const MIX_OPERATION_UNAVAILABLE = "DJ Mixの再生中は、スキップ・シーク・リピート・ここ好きは使えません。";
